import { render, staticRenderFns } from "./AbInput.vue?vue&type=template&id=5022203e&scoped=true"
import script from "./AbInput.vue?vue&type=script&lang=js"
export * from "./AbInput.vue?vue&type=script&lang=js"
import style0 from "./AbInput.vue?vue&type=style&index=0&id=5022203e&prod&lang=scss"
import style1 from "./AbInput.vue?vue&type=style&index=1&id=5022203e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5022203e",
  null
  
)

export default component.exports